import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";

function CircularIndeterminate() {
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "#a0a0a0",
      }}
    >
      <CircularProgress
        size={30}
        color="inherit"
      />
    </Box>
  );
}

export default CircularIndeterminate;
